import { m } from 'framer-motion';
// @mui
import { alpha, useTheme, styled } from '@mui/material/styles';
import { Box, Container, Typography } from '@mui/material';
// components
import { MotionViewport, varFade } from '../../components/animate';

// ----------------------------------------------------------------------

const BENEFITS = [
  {
    icon: '/static/home/saving.webp',
    backdrop: '#FFBCA7',
    description:
      'Kosteneinsparung durch verringerte Personalkosten, sowie verringerter Warenverlust durch verbesserte Prognose der benötigten Warenmenge.',
  },
  {
    icon: '/static/home/benefit.webp',
    backdrop: '#353567',
    description:
      'Biete dem Kunden umfangreiche Vorteile gegenüber anderen Bäckereien wie Bestellfunktionen, Abos und vieles mehr.',
  },
  {
    icon: '/static/home/time.webp',
    backdrop: '#CF7A15',
    description:
      'Backwaren sind für Kunden immer Verfügbar und Wartezeiten an der Bäckerei entfallen.',
  },
];

const shadowIcon = (color: string) => `drop-shadow(2px 2px 2px ${alpha(color, 0.48)})`;

const RootStyle = styled('div')(({ theme }) => ({
  paddingTop: theme.spacing(15),
  [theme.breakpoints.up('md')]: {
    paddingBottom: theme.spacing(15),
  },
}));

const IconStyle = styled('img')(({ theme }) => ({
  width: 50,
  marginRight: theme.spacing(3),
}));

// ----------------------------------------------------------------------

export default function HomeBakerBenefits() {
  const theme = useTheme();

  return (
    <RootStyle>
      <Container component={MotionViewport} maxWidth="md">
        <Box
          sx={{
            textAlign: 'center',
            mb: 10,
          }}
        >
          <m.div variants={varFade().inUp}>
            <Typography component="div" variant="overline" sx={{ mb: 2, color: 'text.disabled' }}>
            Onlineshop
            </Typography>
          </m.div>
          <m.div variants={varFade().inDown}>
            <Typography variant="h2">Der eigene Onlineshop</Typography>
          </m.div>
        </Box>

        <Box sx={{ px: 5 }}>
          {BENEFITS.map((benefit, index) => (
            <Box key={index} sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', mb: 5 }}>
              <IconStyle
                src={benefit.icon}
                alt=""
                sx={{
                  ...{filter: (theme) => shadowIcon(benefit.backdrop)},
                }}
              />
              <m.div variants={varFade().inRight}>
                <Typography sx={{ color: 'text.secondary' }}>
                  {benefit.description}
                </Typography>
              </m.div>
            </Box>
          ))}
        </Box>
      </Container>
    </RootStyle>
  );
}
